import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsContentBlockAssignmentEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsContentBlockAssignmentEntity
